const VoucherValue = {
  PRICE: 1,
  PERCENT: 2,
  PROMOTION: 3
}
export default VoucherValue
